import "./LottieLoading.scss";
import React from "react";
import { Player } from '@lottiefiles/react-lottie-player';
import lottieJSON from './LottieLoading.json';

interface State {
  session: number;
  userData: {};
}

interface Props {
  title?: string;
  handleLogout?: () => void;
  handleHistory?: (url: string) => void;
  state?: State;
  showImageLoader?: boolean;
  hideTappy?: boolean;
}

export const LottieLoading: React.FC<Props> = (props) => {

  const { showImageLoader, hideTappy } = props

  return (
    <Player
      style={showImageLoader === true ? { position: 'unset', width: '100%', height: '100%', padding: 0 } : {}}
      autoplay={true}
      loop={true}
      controls={true}
      src={lottieJSON}
    ></Player>
  )
}